import {
  getAllEntrancesService,
  getAllGradService,
  getAllLstschlService,
  getAllEmpTypeService,
  getAllIndustryService,
  getAllOccupation3Service,
  getAllAnnualIncomeService,
  getDialogIndustryService,
  getDialogOccupationService,
  getDialogPrefService,
  getAllJobDscService,
  getAllAllowanceService,
  getAllAspirationService,
  getAllChangeaddrService,
  getAllCourseService,
  getAllEmployeeService,
  getAllInhabitTypeService,
  getAllJobchangetimeService,
  getAllLanguageLevelService,
  getAllLicenseService,
  getAllListedService,
  getAllOtrlangService,
  getAllPeopleManagementService,
  getAllPeopleManagementYearService,
  getAllSelectionPhaseService,
  getAllSexService,
  getAllStationService,
  getAllWalkBusService,
  getAllWkStatusService,
  getAllYearCategoryService,
  getAllOvertimeHoursService,
  getAllPrefService,
  getAllRemoteWorkService,
  getAllSideJobService,
  getAllWorkCndService,
  getAllApplyService,
  getAllFailureService,
  getAllCityService,
  getAllSchoolService,
  getAllPurpoSeagentService,
} from '@/api/services/mstMyPageService';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import {
  DialogIndustryData,
  DialogIndustryResponseDetail,
  DialogOccupData,
  DialogOccupResponseDetail,
  DialogPrefData,
  DialogPrefResponseDetail,
  Level1MstCityPref,
  MstMyPageItem,
  MstOccupation3,
} from '@/types/mstMyPage';
import { Module } from 'vuex';

type MstMyPageData = {
  mstAnualSlry: MstMyPageItem[];
  mstOvertime: MstMyPageItem[];
  mstRemoteWorkOrder: MstMyPageItem[];
  mstSideBusinessOrder: MstMyPageItem[];
  mstFeatures: MstMyPageItem[];
  mstFeaturesOrder: MstMyPageItem[];
  mstPref: MstMyPageItem[];
  mstCity: MstMyPageItem[];
  mstStation: MstMyPageItem[];
  mstWalkBus: MstMyPageItem[];
  mstEntrance: MstMyPageItem[];
  mstGraduation: MstMyPageItem[];
  dialogOccupation: DialogOccupResponseDetail[];
  dialogPref: DialogPrefResponseDetail[];
  dialogIndustry: DialogIndustryResponseDetail[];
  mstLanguageLevel: MstMyPageItem[];
  mstOtrlang: MstMyPageItem[];
  mstLicenses: MstMyPageItem[];
  mstSex: MstMyPageItem[];
  mstWkStatus: MstMyPageItem[];
  mstLstschl: MstMyPageItem[];
  mstSchool: MstMyPageItem[];
  mstAllowance: MstMyPageItem[];
  mstPeopleManagement: MstMyPageItem[];
  mstPeopleManagementYear: MstMyPageItem[];
  mstInhabitType: MstMyPageItem[];
  mstListed: MstMyPageItem[];
  mstYearCategory: MstMyPageItem[];
  mstIndustry: MstMyPageItem[];
  mstOccupation3: MstOccupation3[];
  mstEmpType: MstMyPageItem[];
  mstChangeaddr: MstMyPageItem[];
  mstEmployee: MstMyPageItem[];
  mstJobchangetime: MstMyPageItem[];
  mstSelectionPhase: MstMyPageItem[];
  mstAspiration: MstMyPageItem[];
  mstCourse: MstMyPageItem[];
  mstApply: MstMyPageItem[];
  mstFailure: MstMyPageItem[];
  mstPurpoSeagent: MstMyPageItem[];
};

type MstMyPageState = {
  mstMyPage: MstMyPageData;
  pendingRequests: Record<string, Promise<any> | null>;
};

const initialState: MstMyPageData = {
  mstAnualSlry: [],
  mstOvertime: [],
  mstRemoteWorkOrder: [],
  mstSideBusinessOrder: [],
  mstFeatures: [],
  mstFeaturesOrder: [],
  dialogOccupation: [],
  dialogPref: [],
  mstPref: [],
  mstCity: [],
  mstStation: [],
  mstWalkBus: [],
  dialogIndustry: [],
  mstEntrance: [],
  mstGraduation: [],
  mstLanguageLevel: [],
  mstOtrlang: [],
  mstLicenses: [],
  mstSex: [],
  mstWkStatus: [],
  mstLstschl: [],
  mstSchool: [],
  mstAllowance: [],
  mstPeopleManagement: [],
  mstPeopleManagementYear: [],
  mstInhabitType: [],
  mstListed: [],
  mstYearCategory: [],
  mstIndustry: [],
  mstOccupation3: [],
  mstEmpType: [],
  mstChangeaddr: [],
  mstEmployee: [],
  mstJobchangetime: [],
  mstSelectionPhase: [],
  mstAspiration: [],
  mstCourse: [],
  mstApply: [],
  mstFailure: [],
  mstPurpoSeagent: []
};

const mstMyPageModule: Module<MstMyPageState, object> = {
  namespaced: true,
  state: {
    mstMyPage: { ...initialState },
    pendingRequests: {},
  },
  getters: {
    mstMyPage: (state) => state.mstMyPage,
    mstAnualSlry: (state) => state.mstMyPage.mstAnualSlry,
    mstOvertime: (state) => state.mstMyPage.mstOvertime,
    mstRemoteWorkOrder: (state) => state.mstMyPage.mstRemoteWorkOrder,
    mstSideBusinessOrder: (state) => state.mstMyPage.mstSideBusinessOrder,
    mstFeatures: (state) => state.mstMyPage.mstFeatures,
    mstFeaturesOrder: (state) => state.mstMyPage.mstFeaturesOrder,
    mstPref: (state) => state.mstMyPage.mstPref,
    mstCity: (state) => state.mstMyPage.mstCity,
    mstWalkBus: (state) => state.mstMyPage.mstWalkBus,
    mstStation: (state) => state.mstMyPage.mstStation,
    mstEntrance: (state) => state.mstMyPage.mstEntrance,
    mstGraduation: (state) => state.mstMyPage.mstGraduation,
    dialogOccupation: (state) => state.mstMyPage.dialogOccupation,
    dialogPref: (state) => state.mstMyPage.dialogPref,
    dialogIndustry: (state) => state.mstMyPage.dialogIndustry,
    mstLanguageLevel: (state) => state.mstMyPage.mstLanguageLevel,
    mstOtrLang: (state) => state.mstMyPage.mstOtrlang,
    mstLicenses: (state) => state.mstMyPage.mstLicenses,
    mstSex: (state) => state.mstMyPage.mstSex,
    mstWkStatus: (state) => state.mstMyPage.mstWkStatus,
    mstLstschl: (state) => state.mstMyPage.mstLstschl,
    mstSchool: (state) => state.mstMyPage.mstSchool,
    mstAllowance: (state) => state.mstMyPage.mstAllowance,
    mstPeopleManagement: (state) => state.mstMyPage.mstPeopleManagement,
    mstPeopleManagementYear: (state) => state.mstMyPage.mstPeopleManagementYear,
    mstInhabitType: (state) => state.mstMyPage.mstInhabitType,
    mstListed: (state) => state.mstMyPage.mstListed,
    mstIndustry: (state) => state.mstMyPage.mstIndustry,
    mstOccupation3: (state) => state.mstMyPage.mstOccupation3,
    mstEmpType: (state) => state.mstMyPage.mstEmpType,
    mstYearCategory: (state) => state.mstMyPage.mstYearCategory,
    mstChangeaddr: (state) => state.mstMyPage.mstChangeaddr,
    mstEmployee: (state) => state.mstMyPage.mstEmployee,
    mstJobchangetime: (state) => state.mstMyPage.mstJobchangetime,
    mstSelectionPhase: (state) => state.mstMyPage.mstSelectionPhase,
    mstAspiration: (state) => state.mstMyPage.mstAspiration,
    mstCourse: (state) => state.mstMyPage.mstCourse,
    mstApply: (state) => state.mstMyPage.mstApply,
    mstFailure: (state) => state.mstMyPage.mstFailure,
    mstPurpoSeagent: (state) => state.mstMyPage.mstPurpoSeagent,
  },
  mutations: {
    setMstAnualSlry(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstAnualSlry = data;
    },
    setMstOvertime(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstOvertime = data;
    },
    setMstRemoteWorkOrder(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstRemoteWorkOrder = data;
    },
    setMstSideBusinessOrder(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstSideBusinessOrder = data;
    },
    setMstFeatures(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstFeatures = data;
    },
    setMstFeaturesOrder(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstFeaturesOrder = data;
    },
    setMstPref(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstPref = data;
    },
    setMstCity(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstCity = data;
    },
    setMstWalkBus(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstWalkBus = data;
    },
    setMstStation(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstStation = data;
    },
    setMstEntrance(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstEntrance = data;
    },
    setMstGraduation(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstGraduation = data;
    },
    setDialogOccupation(state, data: DialogOccupResponseDetail[]) {
      state.mstMyPage.dialogOccupation = data;
    },
    setDialogPref(state, data: DialogPrefResponseDetail[]) {
      state.mstMyPage.dialogPref = data;
    },
    setDialogIndustry(state, data: DialogIndustryResponseDetail[]) {
      state.mstMyPage.dialogIndustry = data;
    },
    setMstLanguageLevel(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstLanguageLevel = data;
    },
    setMstOtrLang(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstOtrlang = data;
    },
    setMstLicenses(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstLicenses = data;
    },
    setMstSex(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstSex = data;
    },
    setMstWkStatus(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstWkStatus = data;
    },
    setMstLstschl(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstLstschl = data;
    },
    setMstSchool(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstSchool = data;
    },
    setMstAllowance(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstAllowance = data;
    },
    setMstInhabitType(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstInhabitType = data;
    },
    setMstPeopleManagement(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstPeopleManagement = data;
    },
    setMstPeopleManagementYear(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstPeopleManagementYear = data;
    },
    setMstEmpType(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstEmpType = data;
    },
    setMstListed(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstListed = data;
    },
    setMstYearCategory(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstYearCategory = data;
    },
    setMstIndustry(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstIndustry = data;
    },
    setMstOccupation3(state, data: MstOccupation3[]) {
      state.mstMyPage.mstOccupation3 = data;
    },
    setMstChangeaddr(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstChangeaddr = data;
    },
    setMstEmployee(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstEmployee = data;
    },
    setMstJobchangetime(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstJobchangetime = data;
    },
    setMstSelectionPhase(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstSelectionPhase = data;
    },
    setMstAspiration(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstAspiration = data;
    },
    setMstCourse(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstCourse = data;
    },
    setMstApply(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstApply = data;
    },
    setMstFailure(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstFailure = data;
    },
    setMstPurpoSeagent(state, data: MstMyPageItem[]) {
      state.mstMyPage.mstPurpoSeagent = data;
    },
    setPendingRequest(state, { key, promise }: { key: string; promise: Promise<any> | null }) {
      state.pendingRequests[key] = promise;
    },
  },
  actions: {
    async fetchMstAnualSlry({ commit, getters, state }) {
      // Check if data already exists in state, return immediately if available
      if (getters.mstAnualSlry && getters.mstAnualSlry.length > 0) {
        return getters.mstAnualSlry;
      }

      // Check if there's already a pending request for this data
      if (state.pendingRequests['mstAnualSlry']) {
        // Return the existing promise to avoid duplicate requests
        return state.pendingRequests['mstAnualSlry'];
      }

      // Create a new promise and handle its resolution
      const promise = getAllAnnualIncomeService()
        .then((data) => {
          if (data && data.length > 0) {
            // Store the fetched data in state
            commit('setMstAnualSlry', data);
          }
          // Clear the pending request reference when completed
          commit('setPendingRequest', { key: 'mstAnualSlry', promise: null });
          return data;
        })
        .catch((error) => {
          // Clear the pending request reference when error occurs
          commit('setPendingRequest', { key: 'mstAnualSlry', promise: null });
          throw error;
        });

      // Store the promise in state to track the pending request
      commit('setPendingRequest', { key: 'mstAnualSlry', promise });

      return promise;
    },

    async fetchMstOvertime({ commit, getters, state }) {
      if (getters.mstOvertime && getters.mstOvertime.length > 0) {
        return getters.mstOvertime;
      }

      if (state.pendingRequests['mstOvertime']) {
        return state.pendingRequests['mstOvertime'];
      }

      const promise = getAllOvertimeHoursService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstOvertime', data);
          }
          commit('setPendingRequest', { key: 'mstOvertime', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstOvertime', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstOvertime', promise });

      return promise;
    },

    async fetchMstRemoteWorkOrder({ commit, getters, state }) {
      if (getters.mstRemoteWorkOrder && getters.mstRemoteWorkOrder.length > 0) {
        return getters.mstRemoteWorkOrder;
      }

      if (state.pendingRequests['mstRemoteWorkOrder']) {
        return state.pendingRequests['mstRemoteWorkOrder'];
      }

      const promise = getAllRemoteWorkService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstRemoteWorkOrder', data);
          }
          commit('setPendingRequest', { key: 'mstRemoteWorkOrder', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstRemoteWorkOrder', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstRemoteWorkOrder', promise });

      return promise;
    },

    async fetchMstSideBusinessOrder({ commit, getters, state }) {
      if (getters.mstSideBusinessOrder && getters.mstSideBusinessOrder.length > 0) {
        return getters.mstSideBusinessOrder;
      }

      if (state.pendingRequests['mstSideBusinessOrder']) {
        return state.pendingRequests['mstSideBusinessOrder'];
      }

      const promise = getAllSideJobService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstSideBusinessOrder', data);
          }
          commit('setPendingRequest', { key: 'mstSideBusinessOrder', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstSideBusinessOrder', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstSideBusinessOrder', promise });

      return promise;
    },

    async fetchMstFeatures({ commit, getters, state }) {
      if (getters.mstFeatures && getters.mstFeatures.length > 0) {
        return getters.mstFeatures;
      }

      if (state.pendingRequests['mstFeatures']) {
        return state.pendingRequests['mstFeatures'];
      }

      const promise = getAllWorkCndService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstFeatures', data);
          }
          commit('setPendingRequest', { key: 'mstFeatures', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstFeatures', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstFeatures', promise });

      return promise;
    },

    async fetchMstFeaturesOrder({ commit, getters, state }) {
      if (getters.mstFeaturesOrder && getters.mstFeaturesOrder.length > 0) {
        return getters.mstFeaturesOrder;
      }

      if (state.pendingRequests['mstFeaturesOrder']) {
        return state.pendingRequests['mstFeaturesOrder'];
      }

      const promise = getAllJobDscService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstFeaturesOrder', data);
          }
          commit('setPendingRequest', { key: 'mstFeaturesOrder', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstFeaturesOrder', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstFeaturesOrder', promise });

      return promise;
    },

    async fetchMstPref({ commit, getters, state }) {
      if (getters.mstPref && getters.mstPref.length > 0) {
        return getters.mstPref;
      }

      if (state.pendingRequests['mstPref']) {
        return state.pendingRequests['mstPref'];
      }

      const promise = getAllPrefService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstPref', data);
          }
          commit('setPendingRequest', { key: 'mstPref', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstPref', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstPref', promise });

      return promise;
    },

    async fetchMstCity({ commit, getters, state }) {
      if (getters.mstCity && getters.mstCity.length > 0) {
        return getters.mstCity;
      }

      if (state.pendingRequests['mstCity']) {
        return state.pendingRequests['mstCity'];
      }

      const promise = getAllCityService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstCity', data);
          }
          commit('setPendingRequest', { key: 'mstCity', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstCity', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstCity', promise });

      return promise;
    },

    async fetchMstWalkBus({ commit, getters, state }) {
      if (getters.mstWalkBus && getters.mstWalkBus.length > 0) {
        return getters.mstWalkBus;
      }

      if (state.pendingRequests['mstWalkBus']) {
        return state.pendingRequests['mstWalkBus'];
      }

      const promise = getAllWalkBusService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstWalkBus', data);
          }
          commit('setPendingRequest', { key: 'mstWalkBus', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstWalkBus', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstWalkBus', promise });

      return promise;
    },

    async fetchMstStation({ commit, getters, state }) {
      if (getters.mstStation && getters.mstStation.length > 0) {
        return getters.mstStation;
      }

      if (state.pendingRequests['mstStation']) {
        return state.pendingRequests['mstStation'];
      }

      const promise = getAllStationService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstStation', data);
          }
          commit('setPendingRequest', { key: 'mstStation', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstStation', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstStation', promise });

      return promise;
    },

    async fetchMstEntrance({ commit, getters, state }) {
      if (getters.mstEntrance && getters.mstEntrance.length > 0) {
        return getters.mstEntrance;
      }

      if (state.pendingRequests['mstEntrance']) {
        return state.pendingRequests['mstEntrance'];
      }

      const promise = getAllEntrancesService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstEntrance', data);
          }
          commit('setPendingRequest', { key: 'mstEntrance', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstEntrance', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstEntrance', promise });

      return promise;
    },

    async fetchMstGraduation({ commit, getters, state }) {
      if (getters.mstGraduation && getters.mstGraduation.length > 0) {
        return getters.mstGraduation;
      }

      if (state.pendingRequests['mstGraduation']) {
        return state.pendingRequests['mstGraduation'];
      }

      const promise = getAllGradService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstGraduation', data);
          }
          commit('setPendingRequest', { key: 'mstGraduation', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstGraduation', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstGraduation', promise });

      return promise;
    },

    async fetchMstInhabitType({ commit, getters, state }) {
      if (getters.mstInhabitType && getters.mstInhabitType.length > 0) {
        return getters.mstInhabitType;
      }

      if (state.pendingRequests['mstInhabitType']) {
        return state.pendingRequests['mstInhabitType'];
      }

      const promise = getAllInhabitTypeService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstInhabitType', data);
          }
          commit('setPendingRequest', { key: 'mstInhabitType', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstInhabitType', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstInhabitType', promise });

      return promise;
    },

    async fetchMstAllowance({ commit, getters, state }) {
      if (getters.mstAllowance && getters.mstAllowance.length > 0) {
        return getters.mstAllowance;
      }

      if (state.pendingRequests['mstAllowance']) {
        return state.pendingRequests['mstAllowance'];
      }

      const promise = getAllAllowanceService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstAllowance', data);
          }
          commit('setPendingRequest', { key: 'mstAllowance', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstAllowance', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstAllowance', promise });

      return promise;
    },

    async fetchMstPeopleManagement({ commit, getters, state }) {
      if (getters.mstPeopleManagement && getters.mstPeopleManagement.length > 0) {
        return getters.mstPeopleManagement;
      }

      if (state.pendingRequests['mstPeopleManagement']) {
        return state.pendingRequests['mstPeopleManagement'];
      }

      const promise = getAllPeopleManagementService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstPeopleManagement', data);
          }
          commit('setPendingRequest', { key: 'mstPeopleManagement', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstPeopleManagement', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstPeopleManagement', promise });

      return promise;
    },
    async fetchMstPeopleManagementYear({ commit, getters, state }) {
      if (getters.mstPeopleManagementYear && getters.mstPeopleManagementYear.length > 0) {
        return getters.mstPeopleManagementYear;
      }

      if (state.pendingRequests['mstPeopleManagementYear']) {
        return state.pendingRequests['mstPeopleManagementYear'];
      }

      const promise = getAllPeopleManagementYearService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstPeopleManagementYear', data);
          }
          commit('setPendingRequest', { key: 'mstPeopleManagementYear', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstPeopleManagementYear', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstPeopleManagementYear', promise });

      return promise;
    },
    async fetchMstListed({ commit, getters, state }) {
      if (getters.mstListed && getters.mstListed.length > 0) {
        return getters.mstListed;
      }

      if (state.pendingRequests['mstListed']) {
        return state.pendingRequests['mstListed'];
      }

      const promise = getAllListedService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstListed', data);
          }
          commit('setPendingRequest', { key: 'mstListed', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstListed', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstListed', promise });

      return promise;
    },
    async fetchMstIndustry({ commit, getters, state }) {
      if (getters.mstIndustry && getters.mstIndustry.length > 0) {
        return getters.mstIndustry;
      }

      if (state.pendingRequests['mstIndustry']) {
        return state.pendingRequests['mstIndustry'];
      }

      const promise = getAllIndustryService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstIndustry', data);
          }
          commit('setPendingRequest', { key: 'mstIndustry', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstIndustry', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstIndustry', promise });

      return promise;
    },

    async fetchMstOccupation3({ commit, getters, state }) {
      if (getters.mstOccupation3 && getters.mstOccupation3.length > 0) {
        return getters.mstOccupation3;
      }

      if (state.pendingRequests['mstOccupation3']) {
        return state.pendingRequests['mstOccupation3'];
      }

      const promise = getAllOccupation3Service()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstOccupation3', data);
          }
          commit('setPendingRequest', { key: 'mstOccupation3', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstOccupation3', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstOccupation3', promise });

      return promise;
    },

    async fetchMstChangeaddr({ commit, getters, state }) {
      if (getters.mstChangeaddr && getters.mstChangeaddr.length > 0) {
        return getters.mstChangeaddr;
      }

      if (state.pendingRequests['mstChangeaddr']) {
        return state.pendingRequests['mstChangeaddr'];
      }

      const promise = getAllChangeaddrService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstChangeaddr', data);
          }
          commit('setPendingRequest', { key: 'mstChangeaddr', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstChangeaddr', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstChangeaddr', promise });

      return promise;
    },

    async fetchMstEmployee({ commit, getters, state }) {
      if (getters.mstEmployee && getters.mstEmployee.length > 0) {
        return getters.mstEmployee;
      }

      if (state.pendingRequests['mstEmployee']) {
        return state.pendingRequests['mstEmployee'];
      }

      const promise = getAllEmployeeService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstEmployee', data);
          }
          commit('setPendingRequest', { key: 'mstEmployee', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstEmployee', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstEmployee', promise });

      return promise;
    },

    async fetchMstJobchangetime({ commit, getters, state }) {
      if (getters.mstJobchangetime && getters.mstJobchangetime.length > 0) {
        return getters.mstJobchangetime;
      }

      if (state.pendingRequests['mstJobchangetime']) {
        return state.pendingRequests['mstJobchangetime'];
      }

      const promise = getAllJobchangetimeService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstJobchangetime', data);
          }
          commit('setPendingRequest', { key: 'mstJobchangetime', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstJobchangetime', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstJobchangetime', promise });

      return promise;
    },

    async fetchMstSelectionPhase({ commit, getters, state }) {
      if (getters.mstSelectionPhase && getters.mstSelectionPhase.length > 0) {
        return getters.mstSelectionPhase;
      }

      if (state.pendingRequests['mstSelectionPhase']) {
        return state.pendingRequests['mstSelectionPhase'];
      }

      const promise = getAllSelectionPhaseService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstSelectionPhase', data);
          }
          commit('setPendingRequest', { key: 'mstSelectionPhase', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstSelectionPhase', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstSelectionPhase', promise });

      return promise;
    },

    async fetchMstAspiration({ commit, getters, state }) {
      if (getters.mstAspiration && getters.mstAspiration.length > 0) {
        return getters.mstAspiration;
      }

      if (state.pendingRequests['mstAspiration']) {
        return state.pendingRequests['mstAspiration'];
      }

      const promise = getAllAspirationService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstAspiration', data);
          }
          commit('setPendingRequest', { key: 'mstAspiration', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstAspiration', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstAspiration', promise });

      return promise;
    },

    async fetchMstCourse({ commit, getters, state }) {
      if (getters.mstCourse && getters.mstCourse.length > 0) {
        return getters.mstCourse;
      }

      if (state.pendingRequests['mstCourse']) {
        return state.pendingRequests['mstCourse'];
      }

      const promise = getAllCourseService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstCourse', data);
          }
          commit('setPendingRequest', { key: 'mstCourse', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstCourse', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstCourse', promise });

      return promise;
    },

    async fetchDialogOccupation({ commit, getters, state }) {
      let rawData: DialogOccupResponseDetail = getters.dialogOccupation;
      if (!rawData?.selectbox1) {
        if (state.pendingRequests['dialogOccupation']) {
          const pendingData = await state.pendingRequests['dialogOccupation'];
          rawData = pendingData;
        } else {
          const promise = getDialogOccupationService()
            .then((data) => {
              if (data) {
                commit('setDialogOccupation', data);
              }
              commit('setPendingRequest', { key: 'dialogOccupation', promise: null });
              return data;
            })
            .catch((error) => {
              commit('setPendingRequest', { key: 'dialogOccupation', promise: null });
              throw error;
            });

          commit('setPendingRequest', { key: 'dialogOccupation', promise });
          rawData = await promise;
        }
      }

      const occupData: DialogOccupData = {
        selectbox1: rawData.selectbox1.map((item) => ({
          isChecked: false,
          isOpened: false,
          ...item,
          selectbox2: rawData.selectbox2
            .filter((item2) => item2.id.toString().substring(0, 1) === item.id)
            .map((item2) => ({
              isChecked: false,
              isOpened: false,
              ...item2,
              selectbox3: rawData.selectbox3
                .filter((item3) => item3.id.toString().substring(0, 3) === item2.id)
                .map((item3) => ({
                  isChecked: false,
                  isOpened: false,
                  ...item3,
                })),
            })),
        })),
      };
      return occupData;
    },

    async fetchDialogPref({ commit, getters, state }) {
      let rawData: DialogPrefResponseDetail = getters.dialogPref;
      if (!rawData?.checkbox1) {
        if (state.pendingRequests['dialogPref']) {
          const pendingData = await state.pendingRequests['dialogPref'];
          rawData = pendingData;
        } else {
          const promise = getDialogPrefService()
            .then((data) => {
              if (data) {
                commit('setDialogPref', data);
              }
              commit('setPendingRequest', { key: 'dialogPref', promise: null });
              return data;
            })
            .catch((error) => {
              commit('setPendingRequest', { key: 'dialogPref', promise: null });
              throw error;
            });

          commit('setPendingRequest', { key: 'dialogPref', promise });
          rawData = await promise;
        }
      }

      const checkbox1 = [...MYPAGE_CONSTANTS.JOB_SEARCH_PUBLIC_AREAS] as Level1MstCityPref[];

      const prefData: DialogPrefData = {
        checkbox1: checkbox1.map((area) => ({
          ...area,
          checkbox2: rawData.checkbox1
            .filter((item1) => Number(item1.areaid) === Number(area.id))
            .map((item1) => ({
              ...item1,
              checkbox3: rawData.checkbox2
                .filter((item2) => item2.id.toString().split('_')[0] === item1.id)
                .map((item2) => ({
                  ...item2,
                  areaid: item1.areaid,
                })),
            })),
        })),
      };
      return prefData;
    },

    async fetchDialogIndustry({ commit, getters, state }) {
      let rawData: DialogIndustryResponseDetail = getters.dialogIndustry;
      if (!rawData?.selectbox1) {
        if (state.pendingRequests['dialogIndustry']) {
          const pendingData = await state.pendingRequests['dialogIndustry'];
          rawData = pendingData;
        } else {
          const promise = getDialogIndustryService()
            .then((data) => {
              if (data) {
                commit('setDialogIndustry', data);
              }
              commit('setPendingRequest', { key: 'dialogIndustry', promise: null });
              return data;
            })
            .catch((error) => {
              commit('setPendingRequest', { key: 'dialogIndustry', promise: null });
              throw error;
            });

          commit('setPendingRequest', { key: 'dialogIndustry', promise });
          rawData = await promise;
        }
      }

      const industryData: DialogIndustryData = {
        selectbox1: rawData.selectbox1.map((item) => ({
          ...item,
          selectbox2: rawData.selectbox2.filter((item2) => item2.id.toString().substring(0, 2) === item.id),
        })),
      };
      return industryData;
    },

    async fetchMstLanguageLevel({ commit, getters, state }) {
      if (getters.mstLanguageLevel && getters.mstLanguageLevel.length > 0) {
        return getters.mstLanguageLevel;
      }

      if (state.pendingRequests['mstLanguageLevel']) {
        return state.pendingRequests['mstLanguageLevel'];
      }

      const promise = getAllLanguageLevelService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstLanguageLevel', data);
          }
          commit('setPendingRequest', { key: 'mstLanguageLevel', promise: null });

          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstLanguageLevel', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstLanguageLevel', promise });

      return promise;
    },

    async fetchMstOtrLang({ commit, getters, state }) {
      if (getters.mstOtrLang && getters.mstOtrLang.length > 0) {
        return getters.mstOtrLang;
      }

      if (state.pendingRequests['mstOtrLang']) {
        return state.pendingRequests['mstOtrLang'];
      }

      const promise = getAllOtrlangService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstOtrLang', data);
          }
          commit('setPendingRequest', { key: 'mstOtrLang', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstOtrLang', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstOtrLang', promise });

      return promise;
    },

    async fetchMstLicenses({ commit, getters, state }) {
      if (getters.mstLicenses && getters.mstLicenses.length > 0) {
        return getters.mstLicenses;
      }

      if (state.pendingRequests['mstLicenses']) {
        return state.pendingRequests['mstLicenses'];
      }

      const promise = getAllLicenseService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstLicenses', data);
          }
          commit('setPendingRequest', { key: 'mstLicenses', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstLicenses', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstLicenses', promise });

      return promise;
    },

    async fetchMstSex({ commit, getters, state }) {
      if (getters.mstSex && getters.mstSex.length > 0) {
        return getters.mstSex;
      }

      if (state.pendingRequests['mstSex']) {
        return state.pendingRequests['mstSex'];
      }

      const promise = getAllSexService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstSex', data);
          }
          commit('setPendingRequest', { key: 'setMstSex', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'setMstSex', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'setMstSex', promise });

      return promise;
    },
    async fetchMstWkStatus({ commit, getters, state }) {
      if (getters.mstWkStatus && getters.mstWkStatus.length > 0) {
        return getters.mstWkStatus;
      }

      if (state.pendingRequests['mstWkStatus']) {
        return state.pendingRequests['mstWkStatus'];
      }

      const promise = getAllWkStatusService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstWkStatus', data);
          }
          commit('setPendingRequest', { key: 'setMstWkStatus', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'setMstWkStatus', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'setMstWkStatus', promise });

      return promise;
    },

    async fetchMstLstschl({ commit, getters, state }) {
      if (getters.mstLstschl && getters.mstLstschl.length > 0) {
        return getters.mstLstschl;
      }

      if (state.pendingRequests['mstLstschl']) {
        return state.pendingRequests['mstLstschl'];
      }

      const promise = getAllLstschlService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstLstschl', data);
          }
          commit('setPendingRequest', { key: 'setMstLstschl', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'setMstLstschl', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'setMstLstschl', promise });

      return promise;
    },
    async fetchMstSchool({ commit, getters, state }) {
      if (getters.mstSchool && getters.mstSchool.length > 0) {
        return getters.mstSchool;
      }

      if (state.pendingRequests['mstSchool']) {
        return state.pendingRequests['mstSchool'];
      }

      const promise = await getAllSchoolService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstSchool', data);
          }
          commit('setPendingRequest', { key: 'mstSchool', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstSchool', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstSchool', promise });

      return promise;
    },

    async fetchMstEmpType({ commit, getters, state }) {
      if (getters.mstEmpType && getters.mstEmpType.length > 0) {
        return getters.mstEmpType;
      }

      if (state.pendingRequests['mstEmpType']) {
        return state.pendingRequests['mstEmpType'];
      }

      const promise = getAllEmpTypeService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstEmpType', data);
          }
          commit('setPendingRequest', { key: 'mstEmpType', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstEmpType', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstEmpType', promise });

      return promise;
    },
    async fetchMstYearCategory({ commit, getters, state }) {
      if (getters.mstYearCategory && getters.mstYearCategory.length > 0) {
        return getters.mstYearCategory;
      }

      if (state.pendingRequests['mstYearCategory']) {
        return state.pendingRequests['mstYearCategory'];
      }

      const promise = getAllYearCategoryService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstYearCategory', data);
          }
          commit('setPendingRequest', { key: 'mstYearCategory', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstYearCategory', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstYearCategory', promise });

      return promise;
    },
    async fetchMstApply({ commit, getters, state }) {
      if (getters.mstApply && getters.mstApply.length > 0) {
        return getters.mstApply;
      }

      if (state.pendingRequests['mstApply']) {
        return state.pendingRequests['mstApply'];
      }

      const promise = getAllApplyService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstApply', data);
          }
          commit('setPendingRequest', { key: 'mstApply', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstApply', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstApply', promise });

      return promise;
    },
    async fetchMstFailure({ commit, getters, state }) {
      if (getters.mstFailure && getters.mstFailure.length > 0) {
        return getters.mstFailure;
      }

      if (state.pendingRequests['mstFailure']) {
        return state.pendingRequests['mstFailure'];
      }

      const promise = getAllFailureService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstFailure', data);
          }
          commit('setPendingRequest', { key: 'mstFailure', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstFailure', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstFailure', promise });

      return promise;
    },
    async fetchMstPurpoSeagent({ commit, getters, state }) {
      if (getters.mstPurpoSeagent && getters.mstPurpoSeagent.length > 0) {
        return getters.mstPurpoSeagent;
      }

      if (state.pendingRequests['mstPurpoSeagent']) {
        return state.pendingRequests['mstPurpoSeagent'];
      }

      const promise = getAllPurpoSeagentService()
        .then((data) => {
          if (data && data.length > 0) {
            commit('setMstPurpoSeagent', data);
          }
          commit('setPendingRequest', { key: 'mstPurpoSeagent', promise: null });
          return data;
        })
        .catch((error) => {
          commit('setPendingRequest', { key: 'mstPurpoSeagent', promise: null });
          throw error;
        });

      commit('setPendingRequest', { key: 'mstPurpoSeagent', promise });

      return promise;
    },
  },
};

export default mstMyPageModule;